import { render, staticRenderFns } from "./MenuResponsive.vue?vue&type=template&id=4dd2f83b&scoped=true"
import script from "./MenuResponsive.vue?vue&type=script&lang=js"
export * from "./MenuResponsive.vue?vue&type=script&lang=js"
import style0 from "./MenuResponsive.vue?vue&type=style&index=0&id=4dd2f83b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../app/browser@vue-cli/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd2f83b",
  null
  
)

export default component.exports